import React from 'react';
import { Box } from 'grommet';
import styled from 'styled-components';
import { StyledSpan } from 'granite-admin/core/components/Animations/SkeletonAnimation';
const ContentBox = styled(StyledSpan)`
  width: calc(100% - 5px);
  height: 15px;
`;
const DateBox = styled(StyledSpan)`
  width: 40%;
  height: 15px;
`;
const NameBox = styled(StyledSpan)`
  width: 80px;
  height: 15px;
`;
const IconBox = styled(StyledSpan)`
  border-radius: 50%;
  width: 45px;
  height: 45px;
`;
const AuditsSkeletonLoader = () => {
  return /*#__PURE__*/React.createElement(Box, {
    gap: "medium",
    fill: true,
    overflow: {
      vertical: 'auto'
    },
    pad: "small"
  }, [...Array(4).keys()].map((i, ind) => /*#__PURE__*/React.createElement(Box, {
    key: ind + 'audit',
    elevation: "small",
    round: "small",
    gap: "medium",
    pad: "medium"
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "row",
    justify: "between",
    align: "center"
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "row",
    gap: "small",
    align: "center"
  }, /*#__PURE__*/React.createElement(IconBox, null), /*#__PURE__*/React.createElement(NameBox, null)), /*#__PURE__*/React.createElement(DateBox, null)), /*#__PURE__*/React.createElement(Box, {
    gap: "small"
  }, [...Array(2).keys()].map((j, index) => /*#__PURE__*/React.createElement(ContentBox, {
    key: index + 'audit-content'
  }))))));
};
export default AuditsSkeletonLoader;